import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { BaivietAction } from 'src/actions/baiviet.action';

import numeral from 'numeral';

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";
import logoNhaMang from "../../assets/images/logo_mang.svg";

const TheHomepageTintucOne = ({ product }) => {
    const dispatch = useDispatch()
    const { itemId } = useParams();
    const { homepageTintucSelected } = useSelector(state => state.baiviet)
    const [title, setTitle] = useState("");
    const [titleFont, setTitleFont] = useState("");
    const [titleFontSize, setTitleFontSize] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [shortDescriptionFont, setShortDescriptionFont] = useState("");
    const [shortDescriptionFontSize, setShortDescriptionFontSize] = useState("");
    const [image, setImage] = useState("");
    const [content, setContent] = useState("");
    const { isLoading } = useSelector(state => state.app);

    useEffect(() => {
        console.log(itemId);
        dispatch(BaivietAction.homepageTintucFindOne(itemId));
    }, [itemId])

    useEffect(() => {
        console.log(homepageTintucSelected);

        setTitle('');
        setTitleFont('');
        setTitleFontSize('');
        setShortDescription('');
        setShortDescriptionFont('');
        setShortDescriptionFontSize('');
        setImage('');
        setContent('');

        if (homepageTintucSelected) {
            setTitle(homepageTintucSelected.title ? homepageTintucSelected.title : '');
            setTitleFont(homepageTintucSelected.title_font ? homepageTintucSelected.title_font : '');
            setTitleFontSize(homepageTintucSelected.title_font_size ? homepageTintucSelected.title_font_size : '');
            setShortDescription(homepageTintucSelected.short_description ? homepageTintucSelected.short_description : '')
            setShortDescriptionFont(homepageTintucSelected.short_description_font ? homepageTintucSelected.short_description_font : '')
            setShortDescriptionFontSize(homepageTintucSelected.short_description_font_size ? homepageTintucSelected.short_description_font_size : '')
            setImage(homepageTintucSelected.image ? homepageTintucSelected.image : '');
            setContent(homepageTintucSelected.content ? homepageTintucSelected.content : '')
        }
    }, [homepageTintucSelected])

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        address: "",
        note: "",
        paymentMethod: "cod",
        itemId,
    });

    return (<>
        <Helmet>
            <title>{title} | Kho số - Di Dong Telecom</title>

            <style>{`
                .post-show .post-title {
                    ${titleFont ? "font-family: " + titleFont + " !important;" : ""}
                    ${titleFontSize ? "font-size: " + titleFontSize + "px !important;" : ""}
                }

                .post-show .post-short-description {
                    ${shortDescriptionFont ? "font-family: " + shortDescriptionFont + " !important;" : ""}
                    ${shortDescriptionFontSize ? "font-size: " + shortDescriptionFontSize + "px !important;" : ""}
                }
            `}</style>
        </Helmet>

        {isLoading && <div className='loading'></div>}

        {!isLoading && <div className='post-show'>
            <h2 className='post-title'>
                {title}
            </h2>
            <div className='post-short-description'>
                {shortDescription}
            </div>
            {image?.match(/\.(mp4|webm|ogg)$/i) ? (
                <video className='post-img media-item' src={image} controls />
            ) : (
                <img className='post-img media-item' src={image} alt={title} />
            )}
            <div className='post-content media-content' dangerouslySetInnerHTML={{ __html: content }} />
        </div>}
    </>);
};

export default TheHomepageTintucOne;